export default "__VITE_ASSET__2C4ieacr__"